
import React from 'react';
import { SimpleGrid } from '@chakra-ui/react';
import ProductCard from './ProductCard';
import { motion } from 'framer-motion';
import ProductGridSkeleton from './ProductGridSkeleton';

const MotionSimpleGrid = motion(SimpleGrid);

const ProductGrid = ({ products, loading, viewMode = 'grid' }) => {
  if (loading) {
    return <ProductGridSkeleton />;
  }

  // Determine columns based on view mode
  const getColumns = () => {
    if (viewMode === 'compact') {
      // 2 columns on mobile in compact mode, standard grid on larger screens
      return { base: 2, sm: 2, md: 3, lg: 3, xl: 4 };
    }
    // Default grid mode
    return { base: 1, sm: 2, md: 3, lg: 3, xl: 4 };
  };

  // Determine spacing based on view mode
  const getSpacing = () => {
    if (viewMode === 'compact') {
      return { base: 2, md: 8 }; // Smaller spacing in compact mode on mobile
    }
    return 8;
  };

  return (
    <MotionSimpleGrid 
      columns={getColumns()}
      spacing={getSpacing()}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {products.map(product => (
        <ProductCard key={product.id} product={product} viewMode={viewMode} />
      ))}
    </MotionSimpleGrid>
  );
};

export default ProductGrid;
